import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { GetImageInfoRequestModel } from "../vo/get-image-info-request.model";
import { GetImageInfoResponseModel } from "../vo/get-image-info-response.model";

/**
 * 画像ファイル一覧取得要求
 */
@Injectable()
export class GetImageInfoService extends PlessJsonResponderSub<any> {

  private vo = new GetImageInfoRequestModel();

  private successFunc: Function;

  private faultFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetImageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        FormId: this.vo.formId,
        PCode: this.vo.pcode,
        GuideGoodsName: this.vo.guideGoodsName,
        GuideStandardName: this.vo.guideStandardName,
        ImageName: this.vo.imageName,
        ImageFileName: this.vo.imageFileName,
        ImageBelongId: this.vo.imageBelongId,
        ImageKind: this.vo.imageKind,
        ImageType: this.vo.imageType,
        ProcessInstruct: this.vo.processInstruct,
        Remarks: this.vo.remarks,
        CookingExPublish: this.vo.cookingExPublish,
        CookingDiv: this.vo.cookingDiv,
        CookingName: this.vo.cookingName,
        MaterialName: this.vo.materialName,
        KeyWord: this.vo.keyWord,
        EventId: this.vo.eventId,
        PhotoContentsDiv: this.vo.photoContentsDiv,
        PhotoStudioId: this.vo.photoStudioId,
        ImageInstructUserId: this.vo.imageInstructUserId,
        ImageInstructDateFrom: this.vo.imageInstructDateFrom,
        ImageInstructDateTo: this.vo.imageInstructDateTo,
        FileRegistDateFrom: this.vo.fileRegistDateFrom,
        FileRegistDateTo: this.vo.fileRegistDateTo,
        Status: this.vo.status,
        ImageInstruct: this.vo.imageInstruct,
        Enabled: this.vo.enabled,
        SortItem: this.vo.sortItem,
        SortOrder: this.vo.sortOrder,
        Page: this.vo.page,
        PhotoScheduleFrom: this.vo.photoScheduleFrom,
        PhotoScheduleTo: this.vo.photoScheduleTo,
        Studio: this.vo.studio,
        ClassCode: this.vo.classCode,
        MultipleCode: this.vo.multipleCode,
        StartOrderCode: this.vo.startOrderCode,
        StartDelivCatalogId: this.vo.startDelivCatalogId,
        BillingName: this.vo.billingName,
        BuyerCode: this.vo.buyerCode,
        OutputFlg: this.vo.outputFlg,
        C2pfStatus: this.vo.c2pfStatus,
        ImageUseProcess: this.vo.imageUseProcess,
        CarriedForward: this.vo.carriedForward,
        C2pfTarget: this.vo.c2pfTarget,
        PhotographingChangeSchedule: this.vo.photographingChangeSchedule,
        SupplierAnnouncement: this.vo.supplierAnnouncement
      }
    });
  }

  /**
   * API呼び出し
   * 
   * @param {GetImageInfoRequestModel} [vo]
   * @param {Function} [successFunc=null]
   * @param {Function} [faultFunc=null]
   * @memberof GetImageInfoService
   */
  execute(vo: GetImageInfoRequestModel, successFunc: Function, faultFunc: Function): void {
    this.successFunc = successFunc;
    this.faultFunc = faultFunc;
    this.vo = vo;
    this.send('KYMW17GetImageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageInfoService
   */
  success(data: any): void {
    if (this.successFunc !== null && data !== null) {
      const response: GetImageInfoResponseModel[] = data.PublishImageData;
      this.successFunc(response);
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {*} errList レスポンスデータ
   * @memberof GetImageInfoService
   */
  plessErrorHandler(errList: Object): void {
    this.faultFunc();
    // 標準処理を続行
    super.plessErrorHandler(errList);
  }
}
